"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _memberFaqUIActionKeys = _interopRequireDefault(require("../constants/memberFaqUIActionKeys"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initalState = {
  selectedTopicName: null,
  selectedTopicId: null
};
var memberFaqUIReducer = (0, _angieslistAppPlatform.createReducer)(initalState, (0, _defineProperty2["default"])({}, _memberFaqUIActionKeys["default"].NEW_FAQ_TOPIC_SELECTED, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedTopicId: action.payload.faqTopicId,
    selectedTopicName: action.payload.faqTopicName
  });
}), false);
var _default = exports["default"] = memberFaqUIReducer;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/reducers/memberFaqUIReducer.js
// module id = 4397
// module chunks = 9